import { useState } from 'react'
import { Box, Image, Spinner, Text } from 'theme-ui'
import CloseButton from './CloseButton'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'

export default function Zoom({ onClose, token }) {
    const [isLoaded, setIsLoaded] = useState(false)

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100vh',
            }}
        >
            <Box
                sx={{
                    position: 'fixed',
                    right: 0,
                    top: 0,
                    p: 4,
                    zIndex: 2,
                }}
            >
                <CloseButton onClick={onClose} />
            </Box>
            <Box
                sx={{
                    display: isLoaded ? 'none' : 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    width: '100vw',
                    height: '100vh',
                }}
            >
                <Spinner strokeWidth={2} />
                <Text sx={{ fontSize: 2, mt: 6, color: 'text' }}>
                    Resizing and exporting your image...
                </Text>
            </Box>
            <Box sx={{ opacity: isLoaded ? 1 : 0 }}>
                <TransformWrapper
                    centerOnInit={true}
                    centerZoomedOut={true}
                    initialScale={1}
                >
                    <TransformComponent
                        wrapperStyle={{
                            cursor: 'all-scroll',
                        }}
                    >
                        <Image
                            onLoad={() => setIsLoaded(true)}
                            loading="lazy"
                            alt="High quality preview of the TinyFacesNFT artwork"
                            src={`${token.direct_url}?type=wide&width=5000`}
                        />
                    </TransformComponent>
                </TransformWrapper>
            </Box>
        </Box>
    )
}
